import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import Checkbox from '../../../form/component/Checkbox'
import ValidationMessageList from '../../../validation/component/ValidationMessageList'
import currentUserHasAccess from '../../../../util/widget-helper'
import { TREATMENT_PAYMENT_WIDGET } from '../../../process/ui-definition/process-ui'


const TreatmentPaymentWidget = ({ readOnly, context, changeProcessContext, saveProcessContext, validationMessageList, salesOrder }) => {
    if (!currentUserHasAccess(TREATMENT_PAYMENT_WIDGET)) {
        return null
    }

    if (salesOrder.type !== 'treatment' && salesOrder.type !== 'treatment-new') {
        return null
    }

    return (
        <ContentBox title="Treatment Payments">
            <Row>
                <Column size={12}>
                    <ValidationMessageList validationMessageList={validationMessageList}/>
                </Column>
            </Row>

            <Row top="M">
                <Column size={12}>
                    <Checkbox
                        object={context}
                        name="physicianPaymentReceived"
                        readOnly={readOnly}
                        onChange={(name, value) => {
                            changeProcessContext(name, value)
                            saveProcessContext()
                        }}
                    >Physician Payment Received
                    </Checkbox>
                </Column>
            </Row>
            <Row top="M">
                <Column size={12}>
                    <Checkbox
                        object={context}
                        name="sunshinePaymentReceived"
                        readOnly={readOnly}
                        onChange={(name, value) => {
                            changeProcessContext(name, value)
                            saveProcessContext()
                        }}
                    >Sunshine Payment Received</Checkbox>
                </Column>
            </Row>

        </ContentBox>
    )
}

TreatmentPaymentWidget.propTypes = {
    readOnly: PropTypes.bool,
    context: PropTypes.object.isRequired,
    changeProcessContext: PropTypes.func.isRequired,
    saveProcessContext: PropTypes.func.isRequired,
    validationMessageList: PropTypes.array.isRequired,
}

export default TreatmentPaymentWidget



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/TreatmentPaymentWidget.js